import { paperMaterialBusiness } from "api/bussiness/paper-material/paper-material-bussiness";
import { workOrderPoBusiness } from "api/bussiness/work-order-po/work-order-po-bussiness";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { boolean, number, string } from "yup";

export const getGoodsIssueItemsArraySchema = () => ({
  workOrderId: {
    type: InputType.none,
  },
  woNumber: {
    type: InputType.text,
    gridSize: 12,
    label: "Số LSX",
    validattionYupSchema: string().nullable(),
  },
  materialId: {
    type: InputType.autoComplete,
    gridSize: 12,
    label: "Vật tư giấy",
    validattionYupSchema: string().required(),
    metaData: {
      searchOptionItemsAsync: async (keyword: string) => {
        return await paperMaterialBusiness.searchPapersAsOptionItems(keyword);
      },
    },
  },
  rollNumber: {
    type: InputType.autoComplete,
    gridSize: 12,
    label: "Số cuồn",
    validattionYupSchema: string(),
  },
  brand: {
    type: InputType.text,
    gridSize: 6,
    label: "Hiệu",
    validattionYupSchema: string(),
    defaultValue: "",
    disabled: true,
  },
  workOrderPOId: {
    type: InputType.autoComplete,
    gridSize: 6,
    label: "Lệnh sản xuất",
    validattionYupSchema: string().required(),
    metaData: {
      searchOptionItemsAsync: async (keyword: string) => {
        return await workOrderPoBusiness.searchWoPoAsOptionItems(keyword);
      },
    },
  },
  length: {
    type: InputType.number,
    gridSize: 12,
    label: "Dài",
    validattionYupSchema: number(),
    defaultValue: 0,
    metaData: {
      fixDecimalScale: 1,
    },
  },
  sheetQuantity: {
    type: InputType.number,
    gridSize: 4,
    label: "S/L Tờ",
    validattionYupSchema: number(),
    defaultValue: 0,
  },
  unitsPerSheet: {
    type: InputType.number,
    gridSize: 4,
    label: "S/L Con/ Tờ",
    validattionYupSchema: number(),
    defaultValue: 0,
  },
  pcsAmount: {
    type: InputType.number,
    gridSize: 4,
    label: "Số lượng (pcs)",
    validattionYupSchema: number(),
    defaultValue: 0,
    disabled: true,
  },
  amount: {
    type: InputType.number,
    gridSize: 12,
    label: "Trọng lượng (kg)",
    validattionYupSchema: number(),
    defaultValue: 0,
    disabled: true,
    metaData: {
      fixDecimalScale: 2,
    },
  },
  isTakeAll: {
    type: InputType.checkbox,
    gridSize: 6,
    label: "Lấy hết",
    validattionYupSchema: boolean(),
    defaultValue: false,
  },
  isWaste: {
    type: InputType.checkbox,
    gridSize: 6,
    label: "Giấy hư",
    validattionYupSchema: boolean(),
    defaultValue: false,
  },
});
